import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { formatCurrency } from "../../../utils/Format";
import {
  Button,
  Container,
  Dialog,
  Typography,
  CircularProgress,
  TextField,
  InputAdornment,
} from "@mui/material";
import useLogout from '../../../hooks/auth/authHook.js';
import { notification } from '../../../utils/Notifications';
import { cashClosing } from '../../../api/userApi';
import styles from "./deliverersConfirmationDialogStyles";

DeliverersConfirmationDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function DeliverersConfirmationDialog({ onClose, open, deliveryMan, totalDeliveredGuides, totalReturnGuides, totalReturnMatrixGuides, getDeliverersDetails, setCorrectAmount, correctAmount }) {
  const [logout] = useLogout();
  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState(0);
  
  const hasGuides = totalDeliveredGuides.length > 0 || totalReturnGuides.length > 0 || totalReturnMatrixGuides.length > 0;
  const validatations = (correctAmount && hasGuides) || (!hasGuides && correctAmount);  
  
  const handleAmountChange = (event) => {
    if(hasGuides) {
      if((/^\d+$/.test(event.target.value)) && parseInt(event.target.value || "0", 10) >= 0 && parseInt(event.target.value || "0", 10) <= deliveryMan?.balance) {
        setCorrectAmount(true);
      } else {
        setCorrectAmount(false);
      }
    } else {
      if((/^\d+$/.test(event.target.value)) && parseInt(event.target.value || "0", 10) > 0 && parseInt(event.target.value || "0", 10) <= deliveryMan?.balance) {
        setCorrectAmount(true);
      } else {
        setCorrectAmount(false);
      }
    }
    setAmount(event.target.value)
  };

  const cashClose = () => {

    if(isLoading) { return; }
    setIsLoading(true);

    cashClosing(deliveryMan.id_delivery_man, totalReturnMatrixGuides, totalReturnGuides, totalDeliveredGuides, amount)
      .then((response) => {
        if (response.data.status_Code === 200) {
          notification({ text: "Corte realizado", type: "success" });
          getDeliverersDetails();
          handleDialogClose();
        } else if (response.data.status_Code === 401) {
          notification({
            text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
            type: "error",
          });
          logout();
        } else {
          notification({
            text: "Error al realizar el corte",
            type: "error",
          });
        }
      })
      .catch((error) => {
        notification({text: 'Error de conexión, revisa tu conexión a internet', type: 'error'});
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const handleOkClick = () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    cashClose();
    setIsLoading(false);
    onClose();
  };

  const handleDialogClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    onClose();
    setAmount(0);
    setCorrectAmount(hasGuides);
  };

  useEffect(() => {
    if (hasGuides) {
      setAmount(0);
      setCorrectAmount(true);
    } else {
      setAmount('');
      setCorrectAmount(false);
    }
  }, [hasGuides]);
  
  return (
    <Dialog
      onClose={handleDialogClose}
      open={open}
      PaperProps={{ style: styles.dialog }}
    >
      <Container style={styles.mainContainer}>
        <Typography component="div" variant="h5" style={styles.title}>
          Realizar corte
        </Typography>
        <Typography component="div" variant="body1" style={styles.subtitle}>
          Antes de realizar el corte válida que las guías sean las
          correctas y que el saldo sea entregado
        </Typography>

        <Container sx={styles.resumeContainer}>
          <Container sx={styles.resumeCountSuccessContainer}>
            <Typography component="div" variant="h5" style={styles.resumeQuantity}>
              {formatCurrency(deliveryMan?.balance)}
            </Typography>
            <Typography component="div" variant="body2" style={styles.resumeSubtitle}>
              Saldo
            </Typography>
          </Container>
          <Container sx={styles.resumeCountInfoContainer}>
            <Typography component="div" variant="h5" style={styles.resumeQuantity}>
              {totalDeliveredGuides.length}
            </Typography>
            <Typography component="div" variant="body2" style={styles.resumeSubtitle}>
              Entregadas
            </Typography>
          </Container>
          <Container sx={styles.resumeCountErrorContainer}>
            <Typography component="div" variant="h5" style={styles.resumeQuantity}>
              {totalReturnGuides.length}
            </Typography>
            <Typography component="div" variant="body2" style={styles.resumeSubtitle}>
              Fallidas
            </Typography>
          </Container>
          <Container sx={styles.resumeCountAlertContainer}>
            <Typography component="div" variant="h5" style={styles.resumeQuantity}>
              {totalReturnMatrixGuides.length}
            </Typography>
            <Typography component="div" variant="body2" style={styles.resumeSubtitle}>
              Devolución
            </Typography>
          </Container>
        </Container>

        { deliveryMan?.balance !== 0 && <Container style={styles.buttonsContainer}>
          <TextField
            id="standard-basic"
            label="Cantidad recibida"
            variant="standard"
            type="number"
            value={amount}
            onChange={handleAmountChange}
            InputProps={{
              inputProps: { min: 0 },
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
        </Container>}

        <Container style={styles.buttonsContainer}>
          <Button
            variant="standard"
            color="primary"
            onClick={handleDialogClose}
            style={styles.cancelButton}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              handleOkClick();
            }}
            disabled={isLoading || !validatations}
            sx={styles.activeButton}
          >
            {isLoading ? (
              <CircularProgress size={24} style={styles.circularProgress} />
            ) : (
              "Realizar corte"
            )}
          </Button>
        </Container>
      </Container>
    </Dialog>
  );
}

// disabled={
//   isLoading || 
//     (
//       (totalDeliveredGuides.length <= 0 && totalReturnGuides.length <= 0 && totalReturnMatrixGuides.length <= 0 && deliveryMan?.balance <= 0) || 
//       /* deliveryMan?.balance <= 0 ||  */
//       !(/^\d+$/.test(amount)) /* || */ 
//       /* parseInt(amount) < 0 ||  */
//       /* parseInt(amount) > deliveryMan?.balance */
//     )
//   /* isLoading ||
//   !(/^\d+$/.test(amount)) ||
//   parseInt(amount) <= 0 ||
//   parseInt(amount) > deliveryMan?.balance */
// }